export class StaffLicenseRenewModel {
    public expiresOn: string;
    public renewedOn: string;
    public id: number;
}